import angular from 'angular';
import { farmnetBaseModule } from '../modules/farmnet/base/farmnet.base.module';

// login
import angularjsLogin from './angularjsLogin';

// login header
import { loginHeaderComponent } from "./login-header/login-header.component";

// registration
import angularjsRegistration from './angularjsRegistration';
import { registrationController } from './registration/registrationController';
import { SelfRegistrationResolver } from './registration/selfRegistrationResolver';

export const loginModuleName = 'login';

// TODO: move to @farmnet/helper
const getUrlSearchFromHash = () => {
  const hash = window.location.hash;
  const search = hash.split('?')[1];

  return search ? '?' + search : '';
};

const getUrlSearchParamValue = (urlSearch, urlParamKey) => {
  const urlParams = new URLSearchParams(urlSearch);
  const urlParamValue = urlParams.get(urlParamKey);

  return urlParamValue;
};


const getSupportedLanguages = () => {
  return ['de', 'en', 'fr', 'pl', 'bg'];
};

const getDefaultLanguage = () => {
  return 'en';
};

const getUserLang = () => {
  let userLang = getDefaultLanguage(); // 'en' is the fallback language

  try {
    userLang = app.languages.current() || app.credentials.locale; // this will only work if the monolith is the entry point

    if (userLang.indexOf('-') !== -1) {
      userLang = userLang.split('-')[0];
    }

    if (!(getSupportedLanguages().includes(userLang))) {
      userLang = getDefaultLanguage();
    }
  }
  catch (error) {
    console.error('[loginModule] Could not retrieve user locale =>', error);
  }

  return userLang;
}

const warnDeprecation = () => {
  console.warn('[loginModule] This module is deprecated and will be removed on: DATE_MUST_BE_DEFINED');
}

angular
  .module(loginModuleName, [
    farmnetBaseModule,
    'ngRoute',
  ])
  .component('angularjsLogin', angularjsLogin)
  .component('angularjsLoginHeader', loginHeaderComponent)
  .component('angularjsRegistration', angularjsRegistration)
  .factory('SelfRegistrationResolver', SelfRegistrationResolver)
  .config(['$routeProvider',
    function config($routeProvider) {
      $routeProvider.when('/registration', {
        redirectTo: () => {
          const queryString = getUrlSearchFromHash();
          const registrationContext = getUrlSearchParamValue(queryString, 'registrationContext');

          if (registrationContext === 'landsberg') {
            window.location.hash = `#/landsberg-registration${queryString}`;
            return;
          }

          window.location.href = `/signon/${getUserLang()}/register${queryString}`;
          warnDeprecation();
        }
      });

      function redirect() {
        const queryString = window.location.search;
        window.location.href = `/signon/${getUserLang()}/login${queryString}`;
        warnDeprecation();
      }
      // waterfall to old registration for landsberg customers
      $routeProvider.when('/landsberg-registration', {
        redirectTo: redirect
      });
      $routeProvider.when('/forgotPwd', {
        // template: '<angularjs-forget-pwd></angularjs-forget-pwd>'
        redirectTo: redirect
      });
      $routeProvider.when('/', {
        // template: '<angularjs-login></angularjs-login>'
        redirectTo: redirect
      });
      // waterfall to old login for landsberg customers
      $routeProvider.when('/landsberg-login', {
        redirectTo: redirect
      });
      $routeProvider.otherwise({
          redirectTo: redirect
      });
    }
  ]);
